import { Link } from 'react-router-dom';
import SupportContacts from '../components/SupportContacts';
import './legal.css';

/**
 * A client's Help & support (Profile → Help & support): the office's own
 * buttons, from Settings, Branding (`SupportContacts`, as the client's chat
 * page and the rider's support page), then the links to the FAQs, terms and
 * privacy. Until 4 Oct 2026 this page wrote one email and a local-form number
 * itself: Settings could not change them, and with Uganda as home the number
 * dialled a Ugandan subscriber, not the office (ingo-59's country census).
 */
export default function HelpSupportPage() {
  return (
    <SupportContacts
      title="Help & Support"
      note="If something looks wrong with a delivery, such as a wrong address or a late rider, contact us and give your order reference if you have one."
    >
      <section className="br-pd-card" aria-label="Quick links">
        <h2 className="br-pd-heading">Quick links</h2>
        <ul className="legal-bullets">
          <li>
            <Link to="/faqs" className="legal-inline-link">
              Frequently asked questions
            </Link>
          </li>
          <li>
            <Link to="/terms" className="legal-inline-link">
              Terms &amp; conditions
            </Link>
          </li>
          <li>
            <Link to="/privacy-policy" className="legal-inline-link">
              Privacy policy
            </Link>
          </li>
        </ul>
      </section>
    </SupportContacts>
  );
}
